module.exports = __webpack_public_path__ + "static/media/ico-add-scenario-small.8981eaa6.svg";